import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";

export const GetOneProjectTechnicalTeamMembers = createAsyncThunk(
  "OneProjectTechnicalTeamMembers/OneGetProjectTechnicalTeamMembers",
  async (tE_TT_ProjectTechnicalTeamMembersId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/TE_TT_ProjectTechnicalTeamMembers/GetTE_TT_ProjectTechnicalTeamMembersData",
        {
          tE_TT_ProjectTechnicalTeamMembersId:
            tE_TT_ProjectTechnicalTeamMembersId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ValidateProjectTechnicalTeamMembers = createAsyncThunk(
  "ProjectTechnicalTeamMembers/ValidateProjectTechnicalTeamMembers",
  async (ProjectTechnicalTeamMembers, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/TE_TT_ProjectTechnicalTeamMembers/ValidateTE_TT_ProjectTechnicalTeamMembers",
        {
          fourPartName: ProjectTechnicalTeamMembers.fourPartName,
          gender: ProjectTechnicalTeamMembers.gender,
          tE_TT_TypeOfWorkId: ProjectTechnicalTeamMembers.tE_TT_TypeOfWorkId,
          idDocumentAttachment:
            ProjectTechnicalTeamMembers.idDocumentAttachment,
          cvDocumentAttachment:
            ProjectTechnicalTeamMembers.cvDocumentAttachment,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      if (response.data.success === true) {
        const arrayValidate = response.data.result.map((ele, ind) => {
          return ele.code;
        });
        return arrayValidate; // Return the extracted data
      }
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const OneProjectTechnicalTeamMembers = createSlice({
  name: "OneProjectTechnicalTeamMembers ",
  initialState: {
    OneProjectTechnicalTeamMembers: {},
    loadingOneProjectTechnicalTeamMembers: false,
    errorOneProjectTechnicalTeamMembers: null,

    ProjectTechnicalTeamMembersValidate: [],
    loadingProjectTechnicalTeamMembersValidate: false,
    errorProjectTechnicalTeamMembersValidate: null,
  },
  reducers: {
    restValidationProjectTechnical: (state, action) => {
      state.ProjectTechnicalTeamMembersValidate = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetOneProjectTechnicalTeamMembers.pending, (state, action) => {
        state.loadingOneProjectTechnicalTeamMembers = true;
        state.OneProjectTechnicalTeamMembers = action.payload;
        state.errorOneProjectTechnicalTeamMembers = null;
      })
      .addCase(GetOneProjectTechnicalTeamMembers.fulfilled, (state, action) => {
        state.loadingOneProjectTechnicalTeamMembers = false;
        state.OneProjectTechnicalTeamMembers = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetOneProjectTechnicalTeamMembers.rejected, (state, action) => {
        state.loadingOneProjectTechnicalTeamMembers = false;
        state.errorOneProjectTechnicalTeamMembers = action.payload;
      })

      .addCase(ValidateProjectTechnicalTeamMembers.pending, (state, action) => {
        state.loadingProjectTechnicalTeamMembersValidate = true;
        state.ProjectTechnicalTeamMembersValidate = action.payload;
        state.errorProjectTechnicalTeamMembersValidate = null;
      })
      .addCase(
        ValidateProjectTechnicalTeamMembers.fulfilled,
        (state, action) => {
          state.loadingProjectTechnicalTeamMembersValidate = false;
          state.ProjectTechnicalTeamMembersValidate = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        ValidateProjectTechnicalTeamMembers.rejected,
        (state, action) => {
          state.loadingProjectTechnicalTeamMembersValidate = false;
          state.errorProjectTechnicalTeamMembersValidate = action.payload;
        }
      );
  },
});
export const { restValidationProjectTechnical } =
  OneProjectTechnicalTeamMembers.actions;
export default OneProjectTechnicalTeamMembers.reducer;
